// extracted by mini-css-extract-plugin
export default {"wrapper":"Cikl2LtOWKP+ltT7+jqrpQ=="};